export default "__VITE_ASSET__5e2nKHGV__"